import ActionType from 'actions/ActionType'

export default (state = '', action) => {
  const switchObj = {
    [ActionType.Tasks.SET_MEDIA_URL]: () => {
      return action.payload
    },
    [ActionType.Tasks.RECEIVE_TASK]: () => {
      return action.payload?.send_sms?.trigger_data?.media_url || ''
    },
  }

  // If the function returns falsey, a ternary is required because
  // if `|| state` is used, state will remain the same
  return switchObj?.[action?.type] ? switchObj[action?.type]?.() : state
}
